
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#5C6970","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75.813h13.938v4.53H19.5V23.5H.75V.812z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M1.5 24C.673 24 0 23.327 0 22.5v-21C0 .673.673 0 1.5 0h12.025A6.483 6.483 0 0120 6.473V12.5a.5.5 0 01-1 0V6.473c0-.153-.007-.312-.022-.473H15.5c-.827 0-1.5-.673-1.5-1.5V1.022A5.127 5.127 0 0013.525 1H1.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h3a.5.5 0 010 1h-3zM15 4.5a.5.5 0 00.5.5h3.297A5.493 5.493 0 0015 1.203V4.5z"}}),_c('path',{attrs:{"d":"M11.5 23.973a.5.5 0 01-.448-.276L9.5 20.591l-1.553 3.105a.498.498 0 01-.671.224.5.5 0 01-.224-.671l1.888-3.776-1.888-3.776a.5.5 0 01.894-.447L9.5 18.355l1.553-3.105a.498.498 0 01.669-.224.5.5 0 01.225.671l-1.888 3.776 1.888 3.776a.5.5 0 01-.447.724zm3.5 0c-1.103 0-2-.897-2-2v-6.5a.5.5 0 011 0v6.5a1 1 0 001 1h2.5a.5.5 0 010 1H15zm4.5 0a.5.5 0 010-1h2.146a1.356 1.356 0 00.606-2.565l-1.95-.975A2.34 2.34 0 0119 17.325a2.357 2.357 0 012.354-2.352H23.5a.5.5 0 010 1h-2.146c-.363 0-.702.141-.958.396a1.343 1.343 0 00-.397.957c-.001.517.287.981.749 1.213l1.951.975a2.357 2.357 0 011.052 3.159 2.343 2.343 0 01-2.104 1.301H19.5v-.001z"}})])
          )
        }
      }
    